import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const UpdateGroupModal = ({ show, handleClose, lngsltd, editGroup, setEditGroup, editGroupNameError, handleUpdate }) => {
    return (
        <Dialog open={show} onClose={handleClose} sx={{
            '& .MuiDialog-paper': {
                width: '20%', // Custom width as a percentage of the screen
                maxWidth: 'none', // Override the maxWidth setting if you want to control width manually
            },
        }}>
            <DialogTitle sx={{ backgroundColor: '#efedf0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                {lngsltd["Update details"]}
                <IconButton edge="end" color="inherit" onClick={handleClose} aria-label="close">
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Box component="form">
                    <TextField
                        fullWidth
                        label={
                            <span>
                                {lngsltd["Group Name"]}
                                <span style={{ color: 'red' }}>*</span>
                            </span>
                        }
                        variant="outlined"
                        placeholder={lngsltd["Enter Group Name"]}
                        value={editGroup}
                        onChange={(e) => setEditGroup(e.target.value)}
                        error={!!editGroupNameError}
                        helperText={editGroupNameError}
                        margin="normal"
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" color="primary" onClick={handleUpdate}>
                    {lngsltd["Save"]}
                </Button>
                <Button variant="outlined" color='error' onClick={handleClose}>
                    {lngsltd["Cancel"]}
                </Button>
            </DialogActions>
        </Dialog>
    )
}